import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    paper: {
      '&$alignCenter': {
        '& $dialogActions': {
          justifyContent: 'center',
        },
      },
    },
    alignCenter: {},

    dialogTitle: {
      padding: theme.spacing(5, 10, 0),
    },
    dialogContent: {
      padding: theme.spacing(2, 10, 0),
    },
    dialogActions: {
      margin: theme.spacing(4, 10),
      justifyContent: 'flex-end',
    },
    buttonClose: {
      position: 'absolute',
      top: '20px',
      right: '20px',
      padding: '20px',

      '& svg': {
        fontSize: '13px',
      },
    },
    title: {
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(26),
      fontWeight: theme.typography.fontWeightMedium,
    },
    content: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      color: theme.palette.text.secondary,
      whiteSpace: 'pre-wrap',
    },
    buttonConfirm: {
      fontSize: theme.typography.pxToRem(14),
      padding: theme.spacing(0, 2),
    },
  }),
  { name: 'PopupInformation' }
);
